// extracted by mini-css-extract-plugin
export default {"container":"container__dSuKY","block":"block__DxhM+"};